// extracted by mini-css-extract-plugin
export var modalBody = "styles-module--modalBody--5ef2d";
export var modalForm = "styles-module--modalForm--d8456";
export var waitListDialog = "styles-module--waitListDialog--c62ef";